import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer";
import Navbar from "../Navbar";
import SponsorForm from "./SponsorForm";
const Sponsor = () => {
  return (
    <div className="Ushno">
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>Become a Sponsor</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Sponsor
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sponsor-part">
        <div className="container__video">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-heading">
                <h2>We care your respons</h2>
              </div>
            </div>
          </div>
          <SponsorForm />
        </div>
      </section>
    </div>
  );
};
export default Sponsor;
